import { Icon } from '@types';

export const Documents = ({ customStyles, handleClick }: Icon) => (
	<svg
		className={customStyles}
		onClick={handleClick}
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		x="0px"
		y="0px"
		viewBox="0 0 450 450"
		xmlSpace="preserve"
	>
		<g>
			<g>
				<path d="M369,378.8H147.2c-16.3,0-29.5-13.2-29.5-29.5V34.5C117.7,18.2,131,5,147.2,5h175.4c2.8,0,5,2.2,5,5s-2.2,5-5,5H147.2    c-10.7,0-19.5,8.7-19.5,19.5v314.8c0,10.7,8.7,19.5,19.5,19.5H369c10.7,0,19.5-8.7,19.5-19.5V84.3c0-2.8,2.2-5,5-5s5,2.2,5,5    v264.9C398.5,365.5,385.3,378.8,369,378.8z" />
				<path d="M393.5,89.3h-70.9c-2.8,0-5-2.2-5-5V10c0-2,1.2-3.9,3.1-4.6c1.9-0.8,4.1-0.3,5.5,1.2l70.9,74.3c1.4,1.4,1.8,3.6,1,5.4    C397.3,88.2,395.5,89.3,393.5,89.3z M327.6,79.3h54.2l-54.2-56.9V79.3z" />
			</g>
			<g>
				<path d="M335.9,411.9H114.1c-16.3,0-29.5-13.2-29.5-29.5V67.6c0-16.3,13.2-29.5,29.5-29.5h8.6c2.8,0,5,2.2,5,5s-2.2,5-5,5h-8.6    c-10.7,0-19.5,8.7-19.5,19.5v314.8c0,10.7,8.7,19.5,19.5,19.5h221.8c10.7,0,19.5-8.7,19.5-19.5v-8.6c0-2.8,2.2-5,5-5s5,2.2,5,5    v8.6C365.4,398.7,352.1,411.9,335.9,411.9z" />
			</g>
			<g>
				<path d="M302.8,445H81c-16.3,0-29.5-13.2-29.5-29.5V100.7c0-16.3,13.2-29.5,29.5-29.5h8.6c2.8,0,5,2.2,5,5s-2.2,5-5,5H81    c-10.8,0-19.5,8.7-19.5,19.5v314.8c0,10.7,8.7,19.5,19.5,19.5h221.8c10.7,0,19.5-8.7,19.5-19.5v-8.6c0-2.8,2.2-5,5-5s5,2.2,5,5    v8.6C332.3,431.8,319,445,302.8,445z" />
			</g>
			<g>
				<path d="M355.8,298.7H160.5c-2.8,0-5-2.2-5-5s2.2-5,5-5h195.3c2.8,0,5,2.2,5,5S358.5,298.7,355.8,298.7z" />
				<path d="M355.8,247.8H160.5c-2.8,0-5-2.2-5-5s2.2-5,5-5h195.3c2.8,0,5,2.2,5,5S358.5,247.8,355.8,247.8z" />
				<path d="M355.8,196.9H160.5c-2.8,0-5-2.2-5-5s2.2-5,5-5h195.3c2.8,0,5,2.2,5,5S358.5,196.9,355.8,196.9z" />
				<path d="M355.8,146H160.5c-2.8,0-5-2.2-5-5s2.2-5,5-5h195.3c2.8,0,5,2.2,5,5S358.5,146,355.8,146z" />
				<path d="M269,95.1H160.5c-2.8,0-5-2.2-5-5s2.2-5,5-5H269c2.8,0,5,2.2,5,5S271.8,95.1,269,95.1z" />
			</g>
		</g>
	</svg>
);
